/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New value`)
};

const es_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor nuevo`)
};

const de_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Wert`)
};

const nl_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe waarde`)
};

const fr_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle valeur`)
};

const it_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo valore`)
};

const pt_br2_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo valor`)
};

const pt_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo valor`)
};

const ja_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい値`)
};

const zh_pct_field_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新值`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_field_new = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_field_new(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_field_new", locale)
	if (locale === "en") return en_pct_field_new(inputs)
	if (locale === "es") return es_pct_field_new(inputs)
	if (locale === "de") return de_pct_field_new(inputs)
	if (locale === "nl") return nl_pct_field_new(inputs)
	if (locale === "fr") return fr_pct_field_new(inputs)
	if (locale === "it") return it_pct_field_new(inputs)
	if (locale === "pt-BR") return pt_br2_pct_field_new(inputs)
	if (locale === "pt") return pt_pct_field_new(inputs)
	if (locale === "ja") return ja_pct_field_new(inputs)
	return zh_pct_field_new(inputs)
};